const step = {
  route: '/homeowners-insurance/quotes/previous-address',
  isAccessible: (props: any) => {
    const {
      currentProperty: { newPurchase, metPreviousAddressRequirement },
    } = props;

    return newPurchase || !metPreviousAddressRequirement;
  },
  breadcrumbStep: 'applicants',
};

export default step;
